import { promptSubscribeBot } from 'System/Preload/PromptSubscribeBot';
import { promptCreateShortcut } from 'System/Preload/PromptCreateShortcut';
import { A2U } from 'Utility/A2U/src/A2U';
import { report } from 'report';
import Game from 'Game';
import { Random } from 'Utility/Random';
import { ArrayHelper } from 'Utility/ArrayHelper';

export async function runAsyncPreloadTasks() {
    // Sequential execution.
    try {
        const isSubscribedToBot = await promptSubscribeBot();
        console.log('Is Subscribed: ', isSubscribedToBot);
        try {
            if (!isSubscribedToBot) {
                // Don't await for this, it will take at least 1 sec per notification
                let remainingA2ULocaleKeys = ['A2U_1', 'A2U_2', 'A2U_3', 'A2U_4', 'A2U_5', 'A2U_6', 'A2U_7'];
                const notifications = [
                    {
                        type: '2hr',
                        timeoutMs: 2 * 60 * 60 * 1000,
                    },
                    {
                        type: '24hr',
                        timeoutMs: 24 * 60 * 60 * 1000,
                    },
                    {
                        type: '48hr',
                        timeoutMs: 48 * 60 * 60 * 1000,
                    },
                    {
                        type: '72hr',
                        timeoutMs: 72 * 60 * 60 * 1000,
                    },
                ].map(notification => {
                    const randomIndex = Random.int(0, remainingA2ULocaleKeys.length - 1);
                    const localeKey = remainingA2ULocaleKeys[randomIndex];

                    remainingA2ULocaleKeys = ArrayHelper.removeIndex(remainingA2ULocaleKeys, randomIndex);

                    return {
                        ...notification,
                        title: 'Solitaire Farm Seasons 4',
                        body: Game.locale.getText(localeKey),
                        mediaUrl:
                            'https://general-public-cdn.softgames.de/bot-service/facebook-instant/solitaire-farm-seasons-dev/A2U_SOFA_1.png',
                    };
                });
                A2U.scheduleNotifications(notifications)
                    .then(results => {
                        console.log('Scheduled A2U Notifications', results);
                    })
                    .catch(error => {
                        report('Failed to schedule A2U notifications', {
                            error,
                            once: true,
                            sampleRate: 0.1,
                            fingerprint: 'A2U:FailedToSchedule',
                        });
                    });
            }
        } catch (error) {
            console.warn('Failed to schedule A2U notifications', error);
        }
    } catch (e) {
        console.warn('Failed to subscribe to bot', e);
    }

    try {
        await promptCreateShortcut();
    } catch (e) {
        console.warn(e);
    }
}
